<template>
    <div class="classification" ref="mainContainer">
        <div style="margin: 16px 0px; display: flex; align-items: center;">
            <el-input v-model="searchName" placeholder="请输入名称" size="small" clearable style="width: 220px; margin-right: 10px;" @keyup.enter.native="search" @clear="search"></el-input>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            <el-button size="small" icon="el-icon-refresh" @click="reset">重置</el-button>
            <el-button size="small" type="primary" @click="add" style="margin-left: 10px;">新增</el-button>
        </div>
        <el-table :data="tableData" style="width: 100%;" :max-height="tableHeight" v-if="tableHeight">
            <el-table-column prop="name" label="产品名称">
            </el-table-column>
            <el-table-column prop="updateTime" label="更新时间" width="180">
            </el-table-column>
            <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope">
                    <el-button size="small" type="text" style="margin: auto;" @click="edit(scope.row)">编辑</el-button>
                    <el-button size="small" type="text" style="margin: auto;" @click="deleteItem(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <Pagination :total="page.pages"
                    :page.sync="page.current"
                    :limit.sync="page.size"
                    @pagination="changeSize"/>
        <el-dialog :title="editTitle" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false">
            <el-input placeholder="请输入" v-model="goodsName" :autofocus="true"></el-input>
            <div class="flexEnd">
                <el-button size="small" type="default"  @click="handleClose">返回</el-button>
                <el-button size="small" type="primary" @click="addAction">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Pagination from '@/components/Pagination'
import { getBlacklist,goodesBlackAdd,goodesBlackDelete ,goodesBlackUpdate} from "@/api/goodsBlackList";
export default {
    components: {
        Pagination,
    },
    data() {
        return {
            tableData: [],
            searchName: '',
            editTitle: '新增',
            dialogVisible:false,
            goodsName:'',
            editData:undefined,
            page: {
                current: 1,
                size: 10,
                pages: 0,
            },
            tableHeight:0
        }
    },
    created() {
        this.getList()
        
    },
    mounted(){
        
        let containerHeight = parseFloat(this.$refs['mainContainer'].offsetHeight)
        this.tableHeight = containerHeight - 110
        console.log(this.tableHeight);
        
    },
    methods: {
        getList() {
            let obj ={
                current: this.page.current,
                size: this.page.size,
                name: this.searchName,
            }
            getBlacklist(obj).then((resp) => {
                if (resp.data && resp.data.records) {
                    this.tableData = resp.data.records
                    this.page.pages = resp.data.total
                }
            })
        },
        handleClose(){
            this.dialogVisible = false
            this.goodsName = ''
        },
        addAction(){
            if (this.editTitle == "新增") {
                goodesBlackAdd({name:this.goodsName}).then((resp)=>{
                    if (resp.code == 0) {
                        this.$message.success('新增成功')
                        this.handleClose()
                        this.getList()
                    }
                })
            } else {
                goodesBlackUpdate({name:this.goodsName,id:this.editData.id}).then((resp)=>{
                    if (resp.code == 0) {
                        this.$message.success('新增成功')
                        this.handleClose()
                        this.getList()
                    }
                })
            }
        },
        add() {
            this.editTitle = '新增'
            this.dialogVisible = true
        },
        edit(item) {
            this.editTitle = '编辑'
            this.dialogVisible = true
            this.editData = item
            this.goodsName = item.name
        },
        deleteItem(item){
            goodesBlackDelete({id: item.id }).then((resp)=>{
                if (resp.code == 0) {
                    this.$message.success('删除成功')
                    this.handleClose()
                    this.getList()
                }
            })
        },
        changeSize(){
            this.getList()
        },
        search(){
            this.page.current = 1
            this.getList()
        },
        reset(){
            this.searchName = ''
            this.page.current = 1
            this.getList()
        }
    }
}
</script>

<style lang="scss" scoped>
.flexEnd{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 16px 0px;
}
</style>